import { combineReducers } from "redux";
import { ScopeLoadingState } from "./scope-loading/types";
import { ScopeErrorState } from "./scope-error/types";
import { scopeLoadingReducer } from "./scope-loading/reducer";
import { scopeErrorReducer } from "./scope-error/reducer";
import { ClaimState } from "./claim/types";
import { claimReducer } from "./claim/reducer";

export interface RootState {
  scopeLoading: ScopeLoadingState;
  scopeError: ScopeErrorState;
  claim: ClaimState;
}

const createRootReducer = () =>
  combineReducers({
    claim: claimReducer,
    scopeLoading: scopeLoadingReducer,
    scopeError: scopeErrorReducer,
  });

export default createRootReducer;
